import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Track whether the client has ever seen an authenticated success. If a 401
// hits AFTER we've been authenticated (session expired mid-usage), we bounce
// to /login. Anonymous 401s (page load before login) just resolve silently.
// (Currently unused — the auto-redirect proved race-condition prone.)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      return Promise.resolve({
        ...error.response,
        data: null,
        _authFailed: true,
      });
    }
    return Promise.reject(error);
  }
);

// Belt-and-suspenders: also swallow any residual 401 unhandled rejections
// (e.g., from a race before the interceptor runs) so React's dev-mode
// error overlay never surfaces routine auth failures.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    const status = event?.reason?.response?.status;
    if (status === 401 || status === 403) {
      event.preventDefault();
    }
  });
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
